<div [ngClass]="fromEmployee ? 'employee-validation' : 'validation'">
  {{ errorMessage | translate }}
</div>
